module.exports = __webpack_public_path__ + "static/img/bcg.497328a7.webp";